import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { from } from "rxjs";
import { CanActivate } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PermissionService } from "../permission.service";

@Injectable({
    providedIn: "root",
  })
  export class AssististCategoriesListGuard implements CanActivate {
    constructor(
      private PermissionService: PermissionService,
      private router: Router,
    ) {}
  
    canActivate(): boolean | Observable<boolean> {
      return from(this.PermissionService.categories.assististCategories?.hasList() || Promise.resolve(false)).pipe(
        map((hasAccess) => {
          if (!hasAccess) {
            this.router.navigate([""]);
          }
          return hasAccess;
        }),
      );
    }
  }
  
  @Injectable({
    providedIn: "root",
  })
  export class AssististCategoriesWriteGuard implements CanActivate {
    constructor(
      private PermissionService: PermissionService,
      private router: Router,
    ) {}
  
    canActivate(): boolean | Observable<boolean> {
      return from(this.PermissionService.categories.assististCategories?.hasWrite() || Promise.resolve(false)).pipe(
        map((hasAccess) => {
          if (!hasAccess) {
            this.router.navigate([""]);
          }
          return hasAccess;
        }),
      );
    }
  }
  
  @Injectable({
    providedIn: "root",
  })
  export class AssististCategoriesDetailGuard implements CanActivate {
    constructor(
      private PermissionService: PermissionService,
      private router: Router,
    ) {}
  
    canActivate(): boolean | Observable<boolean> {
      return from(this.PermissionService.categories.assististCategories?.hasDetail() || Promise.resolve(false)).pipe(
        map((hasAccess) => {
          if (!hasAccess) {
            this.router.navigate([""]);
          }
          return hasAccess;
        }),
      );
    }
  }

  @Injectable({
    providedIn: "root",
  })
  export class AssististDocumentsListGuard implements CanActivate {
    constructor(
      private PermissionService: PermissionService,
      private router: Router,
    ) {}
  
    canActivate(): boolean | Observable<boolean> {
      return from(this.PermissionService.categories.assististDocuments?.hasList() || Promise.resolve(false)).pipe(
        map((hasAccess) => {
          if (!hasAccess) {
            this.router.navigate([""]);
          }
          return hasAccess;
        }),
      );
    }
  }
  
  @Injectable({
    providedIn: "root",
  })
  export class AssististDocumentsWriteGuard implements CanActivate {
    constructor(
      private PermissionService: PermissionService,
      private router: Router,
    ) {}
  
    canActivate(): boolean | Observable<boolean> {
      return from(this.PermissionService.categories.assististDocuments?.hasWrite() || Promise.resolve(false)).pipe(
        map((hasAccess) => {
          if (!hasAccess) {
            this.router.navigate([""]);
          }
          return hasAccess;
        }),
      );
    }
  }
  
  @Injectable({
    providedIn: "root",
  })
  export class AssististDocumentsDetailGuard implements CanActivate {
    constructor(
      private PermissionService: PermissionService,
      private router: Router,
    ) {}
  
    canActivate(): boolean | Observable<boolean> {
      return from(this.PermissionService.categories.assististDocuments?.hasDetail() || Promise.resolve(false)).pipe(
        map((hasAccess) => {
          if (!hasAccess) {
            this.router.navigate([""]);
          }
          return hasAccess;
        }),
      );
    }
  } 